import { Component } from '@angular/core'

@Component({
  templateUrl: './global-admin.page.html',
})
export class GlobalAdminPage {}
